import * as React from 'react';
import Skeleton from 'react-loading-skeleton';

import { useTokenStats } from '~common/hooks/useTokenStats';
import { fNum } from '~utils';

export function TVLInfo() {
  const { tvl } = useTokenStats();

  return (
    <div className="inline-block bg-dark3 bg-opacity-50 px-6 text-center rounded-lg shadow-2xl">
      <div className="text-2xl brand-text">
        {tvl > 0 ? `$${fNum(tvl)}` : <Skeleton className="w-12" />}
      </div>
      <div className="opacity-50">TVL</div>
    </div>
  );
}
